import apiCore from '../../utils/api-core'

export default {
	markGettingStartedStepCompleted(query,data) {
		return apiCore.put(`/api/v1/users/${query}/guide/complete`, data);
	},
    getGettingStartedGuideMeta(query) {
		return apiCore.get(`/api/v1/users/${query}/guide`);
	},
}